export enum GuardianInvitationStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Declined = 'declined',
  Revoked = 'revoked',
  Expired = 'expired',
}

export enum GuardianInvitationSubmissionAction {
  Accept = 'accept',
  Decline = 'decline',
}

export enum GuardianInvitationRelationship {
  Parent = 'parent',
  Grandparent = 'grandparent',
  Coach = 'coach',
  Other = 'other',
}

export enum GuardianInvitationActionStatus {
  Accepted = 'accepted',
  Declined = 'declined',
}

export enum GuardianInvitationErrorReason {
  LoginRequired = 'login_required',
  EmailMismatch = 'email_mismatch',
  Expired = 'expired',
  AlreadyProcessed = 'already_processed',
  InvalidLink = 'invalid_link',
  Unknown = 'unknown',
}

export type GuardianInvitationPreview = {
  status: GuardianInvitationStatus;
  invitedEmail?: string;
  playerName: string;
  invitedByName: string;
  relationship: GuardianInvitationRelationship;
  message?: string;
  expiresAt: string;
};

export type GuardianInvitationAction = {
  status: GuardianInvitationActionStatus;
  playerId: string;
};
